import { useQuery } from '@tanstack/react-query';

import { useToast } from '@aslanpay/portal-common-lib';

import { RECONCILIATION_POLL_INTERVAL_MS } from 'app/constants/reconciliations';

import ReconciliationsApiHandler from 'app/services/reconciliationsApiHandler';

import { ReconciliationRun } from 'app/types/reconciliations';

import { isActiveReconciliationRun } from 'app/utils/reconciliations';

export const RECONCILIATION_QUERY_KEY = 'fetchReconciliation';

/** Reads one reconciliation run, refreshing while it is still queued or running. */
const useFetchReconciliation = (id?: string) => {
  const toast = useToast();

  return useQuery<ReconciliationRun, Error>(
    [RECONCILIATION_QUERY_KEY, id],
    () => ReconciliationsApiHandler.getReconciliation(id as string),
    {
      enabled: !!id,
      refetchInterval: (data) =>
        isActiveReconciliationRun(data) ? RECONCILIATION_POLL_INTERVAL_MS : false,
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: 'Sorry, we failed to fetch the reconciliation. Please try again.',
        });
      },
    }
  );
};

export default useFetchReconciliation;
